/**
 * src/shared/config/syncFlags.ts
 *
 * Phase 36 (SYNC-02) — producer kill switch.
 *
 * This is an OPERATOR EMERGENCY OFF-SWITCH, not a feature flag for a dark launch.
 * CLAUDE.md rule 11 forbids shipping a feature that is built but unreachable — a
 * producer disabled by default would never enqueue a single change in production,
 * exactly that anti-pattern. It defaults to ENABLED and is disabled ONLY by the
 * literal string 'false', letting an operator kill the producer with a one-line
 * env change + redeploy if a staged rollout goes wrong (see 36-03-PLAN.md
 * reversibility note — already-queued records survive the flip and drain when it
 * is flipped back).
 *
 * Mirrors the import.meta.env.VITE_* read precedent in src/lib/auth-client.ts:5.
 */
export const SYNC_PRODUCER_ENABLED: boolean =
  import.meta.env.VITE_SYNC_PRODUCER_ENABLED !== 'false';
